const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/live/$roomSlug/_protected/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

// Key on roomSlug so the component fully remounts on each navigation between
// rooms. Without this, TanStack Router re-renders the same instance and
// useState retains stale currentParticipant from the previous room.

export const Route = createFileRoute("/_minimal/live/$roomSlug/_protected/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});